// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Xz4+o","inner":"styles_inner__o-d18","text":"styles_text__IvWTD","subtext":"styles_subtext__9XtXx"};